import { render, staticRenderFns } from "./BeAffectedPerson.vue?vue&type=template&id=c4dbe60e&scoped=true&"
import script from "./BeAffectedPerson.vue?vue&type=script&lang=js&"
export * from "./BeAffectedPerson.vue?vue&type=script&lang=js&"
import style0 from "./BeAffectedPerson.vue?vue&type=style&index=0&id=c4dbe60e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dbe60e",
  null
  
)

export default component.exports